import type { ErrorResponse } from "./models/error-response";
import type { SuccessfulResponse } from "./models/successful-response";
import type { Aggregation } from "./models/aggregation";
import type { Pagination } from "./models/pagination";
import type { ProductDetailGrid } from "./models/product-detail-grid";

export type SearchImageSetPayload = {
  image: File | null;
};

export type ImageSearchStateType = {
  image: File | null;
};

export enum StylingAbbrType {
  SH = "sh",
  SB = "sb"
}

export type SearchResultStateType = {
  searchImage: string;
  bounds: any[];
  productIds: string[];
  visualProducts: any[];
  // item tag 信息
  result: ResultInfo;
  resultForGa: ResultInfo;
  categoryType: string;
  // outfits
  productItemIds: string[];
  outFitResult: OutfitResult;
  backupOutFitResult: OutfitResult;
  resultItemloading: boolean;
  visibleOutfitloading: boolean;
  visibleOutfitHasNextPageLoading: boolean;
  outfitHasMore: boolean;
  visualSearchNoData: boolean;
  isChangedItemFilterFlag: boolean;
  isChangeItemSortFlag: boolean;
  isFilterSortItemError: boolean;
  isChangedOutfitFilterFlag: boolean;
  isChangeOutfitSortFlag: boolean;
  isFilterSortOutfitError: boolean;
};

export type AppStateType = {
  language: string;
  region: string;
  brand_name: string;
  isVisibleError: boolean;
  isVisibleLogin: boolean;
  isVisibleNotFound: boolean;
  isApp: boolean;
  isVisibleErrorModal: boolean;
  isOutfitFilterError: boolean;
  isOutfitOrderError: boolean;
  isVisibleUploadErrorModal: boolean;
  changeItemOrderFlag: boolean;
  changeOutfitOrderFlag: boolean;
  isTagDotActive: boolean;
};

export type QuestionnaireEachType = {
  type: string;
  number: number;
  question: string;
  answer?: any;
  value?: string;
  options: any;
};

export type FeedbackStateType = {
  isVisibleFeedbackModal: boolean;
  visualSearchReqResult: string;
  productReqResult: string;
  questionnaireData: Array<QuestionnaireEachType>;
  image_file: any;
  isUploadedImageSuccess: boolean;
};

export type FavoritesItemStateType = {
  isPopupShown: boolean;
  currentItemInfo: any;
  itemLoading: boolean;
  favoritesItemList: any;
  sysError: boolean;
  skusLoading: boolean;
  allL2s: any;
  images?: ItemWishListImagesData;
};
export interface ItemWishListImagesData {
  main: {
    [color: string]: ItemWishListMainData;
  };
  chip: {
    [color: string]: string;
  };
}
export interface ItemWishListMainData {
  image: string;
}

export type CombinedReducersType = {
  app: AppStateType;
  favoritesItem: FavoritesItemStateType;
  imageSearch: ImageSearchStateType;
  searchResult: SearchResultStateType;
  feedback: FeedbackStateType;
};

export interface ResultInfo {
  aggregations: Aggregation;
  pagination: Pagination;
  items: ProductDetailGrid[];
  initFlag?: boolean;
}

export enum RESULT_TAB {
  ITEM = "product",
  OUTFIT = "outfit"
}

export enum CATEGORY_TYPE {
  GENDERS = "genders",
  CLASSES = "classes",
  CATEGORYS = "categories",
  SUB_CATEGORIES = "subcategories"
}

export type GetProductsArgs = {
  productsIds: string[];
  path?: string[];
  sizeCodes?: string[];
  limit?: number;
  sort?: number;
  callback?: (
    sizes: any,
    tree: any[],
    result?: any,
    categoryType?: string
  ) => void;
};

export type VisualSearchArgs = {
  minScore: string;
  image: any;
  callback: (productIds: any[], similarProducts: any[]) => void;
  tagName?: string;
};

export enum PORDUCT_SORT {
  SIMILAR = "0",
  RECENCY = "1"
}

export enum OUTFIT_SORT {
  RECENCY = "display_start_at"
}

export type GenderCategory = "MEN" | "WOMEN" | "KIDS" | "BABY" | "UNISEX";
export type SizeGender = "MEN" | "WOMEN" | "KIDS" | "BABY" | "NO_GENDER";
export interface ProductDetail extends ProductDetailGrid {
  favorite?: boolean;
  genderCategory?: GenderCategory;
  sizeGender?: SizeGender;
}

export type Point = {
  x: number;
  y: number;
};

export type Bound = {
  bounding_poly: {
    normalized_vertices: Point[];
  };
  intermediate_categories: any;
  name: string;
  score: number;
  selectedName: string;
};

export type Response = {
  status?: any;
  result?: any;
  error?: any;
};

export type OutfitHeight = {
  label: string;
  value: string;
};
export type OptionsType = {
  key: string;
  value: string;
  code?: string;
  min?: string;
  max?: string;
  lid?: string;
};
export type GenderHeightConfig = {
  Women: OutfitHeight[];
  Men: OutfitHeight[];
  Kids: OutfitHeight[];
  Baby: OutfitHeight[];
  All: OutfitHeight[];
  KidsBabys?: OutfitHeight[];
};
export type SelectedGender = keyof GenderHeightConfig;
export type GenderHeightConfigUsEn = {
  WOMEN: OutfitHeight[];
  MEN: OutfitHeight[];
  KIDS: OutfitHeight[];
  BABY: OutfitHeight[];
  All: OutfitHeight[];
};

export interface GetOutfitArgs {
  productIds: string[];
  height?: string;
  gender?: number | string;
  offset?: number;
  limit?: number;
  region?: string;
  language?: string;
  callback?: () => void;
}

export interface OutfitQueryParams {
  productId: string;
  genderCode?: string;
  minModelHeight?: number;
  maxModelHeight?: number;
  offset?: number;
  limit?: number;
  order?: string;
  unit?: string;
}

export type OutfitDetail = {
  imageUrl: string;
  outfitType: string;
  styleId: number;
  favorite?: boolean;
};

export interface OutfitResult {
  offset: number;
  total: number;
  similarOutfits: OutfitDetail[];
}

export type LocalizedInfo = {
  bounding_poly: any;
  intermediate_categorie: string[];
  name: string;
  score: number;
};

export type SimilarProducts = {
  brand: string;
  category_ids: string[];
  category_names: string[];
  color_code: string;
  color_name: string;
  display_color_code: string;
  display_name: string;
  ec_item_mobile_url: string;
  ec_item_url: string;
  gender: string;
  im_name: string;
  image_url: string;
  in_stock: string;
  intermediate_categories: string[];
  name: string;
  primary_color: string;
  region: string;
  sales_start_at: string;
  score: number;
  sizes: string[];
  unified_gender: string;
  upstream_product_id: string;
};

export type VisualSearchItem = {
  localized_info: LocalizedInfo;
  search_index_time: string;
  similar_products: SimilarProducts[];
};

export type Size = {
  code: string;
  displayCode: string;
  docCount: number;
  name: string;
  [key: string]: any;
};
export type FlagColorEnum = "normal" | "discount";

export interface FlagComponent {
  code: string; // Identifiers for the flags
  id: number;
  name: string; // Localized name of the product's flags
  flagColor: FlagColorEnum;
  nameWording?: {
    flagWithTime: string; // Localization ID of flag test with time. Clients should use this field instead of name if its present.
    substitutions?: {
      date?: string;
      month?: string;
      flagName?: string;
    };
  };
}

export enum Media {
  APP = "app",
  WEB = "web"
}

export enum DeviceType {
  PC = "PC",
  SP = "SP",
  RS = "RS" // * Responsive
}

export enum BRAND_LIST {
  UQ = "uq",
  GU = "gu",
  PL = "pl"
}

export enum BRAND_NAME_LIST {
  UQ = "uniqlo",
  GU = "gu",
  PL = "plst"
}

export enum BRAND_NAME_FOR_META {
  UQ = "UNIQLO",
  GU = "GU",
  PL = "PLST"
}

export enum GABrandList {
  UQ = "uq",
  GU = "GU",
  PL = "PL"
}

export type GeneratePath = {
  language: string;
  region: string;
  type: string;
};

export type FirebaseResult = {
  minScore: string;
  imagesearch_wish: string;
};

export interface ItemWishlistData {
  isPopupShown: boolean;
  currentItemInfo: any;
  itemLoading: boolean;
  favoritesItemList: Array<string>;
  sysError: boolean;
  skusLoading: boolean;
  allL2s: {
    [color: string]: L2[];
  };
  images?: ItemWishListImagesData;
}

export type WishlistL2ItemType = {
  l2Id: string;
  productId: string;
  display: boolean;
  isRepresentative: boolean;
};

export interface ProductSkusPayload {
  productId: string;
  priceGroup: string;
}

export type L2 = {
  l2Id: string;
  color: SizeColorType;
  size: SizeColorType;
  pld: PatternLengthDimensionFrontend;
  isWishlisted: boolean;
  imageUrl: string;
};

export type SizeColorType = {
  name: string;
  code: string;
  displayCode: string;
  filterCode: string;
  display: Display;
};

export type PatternLengthDimensionFrontend = {
  name: string;
  code: string;
  displayCode: string;
  filterCode: string;
  display: Display;
};

export type Display = { showFlag: boolean; chipType: number };

export type {
  ErrorResponse,
  SuccessfulResponse,
  Aggregation,
  Pagination,
  ProductDetailGrid
};
export declare const IMAGE_RATIO_1X1 = "1x1";
export declare const IMAGE_RATIO_16X9 = "16x9";
export declare const IMAGE_RATIO_3X4 = "3x4";
export declare const IMAGE_RATIO_4X3 = "4x3";
export declare const IMAGE_RATIO_2X1 = "2x1";
export declare const IMAGE_RATIO_6X1 = "6x1";
export declare const IMAGE_RATIO_3X1 = "3x1";
export declare const IMAGE_RATIO_5X2 = "5x2";
export declare const IMAGE_FULL_WIDTH = "full-width";
export type ImageRatio =
  | typeof IMAGE_RATIO_1X1
  | typeof IMAGE_RATIO_16X9
  | typeof IMAGE_RATIO_3X4
  | typeof IMAGE_RATIO_4X3
  | typeof IMAGE_RATIO_3X1
  | typeof IMAGE_RATIO_6X1
  | typeof IMAGE_RATIO_5X2
  | typeof IMAGE_RATIO_2X1
  | typeof IMAGE_FULL_WIDTH;
